import React from "react";
import Modal from "react-modal";
import moment from "moment";
import ModalContent from "../../common/Modal/ModalContent";
import { Button } from "../../common/Button/Button";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import HandholderAssignment from "../ServiceRequests/Admin/HandholderAssignment";
import { X } from "react-feather";
import Spinner from "../../common/Spinner/Spinner";

export default function ReassignmentModal(props) {
	const renderRelatedServices = () => {
		if (props.relatedServices.length !== 0) {
			let temp = props.relatedServices.map((e) => {
				return (
					<tr>
						<td style={{ width: "14%" }}>
							{e["nResourceInstanceId"]}
						</td>
						<td style={{ width: "14%" }}>
							{e["sFirstName"]} {e["sLastName"]}
						</td>

						<td style={{ width: "14%" }}>{e["sEmailAddress"]}</td>
						<td style={{ width: "14%" }}>{e["sContactNumber"]}</td>

						<td style={{ width: "14%" }}>{e["sServiceCode"]}</td>
						<td style={{ width: "14%" }}>
							{e?.dtFollowupOn ? moment(e["dtFollowupOn"]).format("DD/MM/YYYY") : ""}
						</td>
						<td style={{ width: "14%" }}>{e["refSRState"]}</td>
					</tr>
				);
			});

			return (
				<table>
					<thead>
						<th>
							<span>Instance Id</span>
						</th>
						<th>
							<span>Name</span>
						</th>
						<th>
							<span>Email(SR)</span>
						</th>
						<th>
							<span>Phone Number(SR)</span>
						</th>
						<th>
							<span>Service Code</span>
						</th>
						<th>
							<span>Followup Date</span>
						</th>
						<th>
							<span>status</span>
						</th>
					</thead>
					<tbody>{temp}</tbody>
				</table>
			);
		} else {
			return (
				<>
					<span
						style={{
							padding: "10px 10px",
							paddingInline: "10px",
							backgroundColor: "#eac1c1",
							display: "inline-block",
						}}
					>
						No services found
					</span>
				</>
			);
		}
	};

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				<div
					className={`status-column  ${props.isLoadingServices && "set-opacity"
						}`}
				>
					{props.isLoadingServices ? (
						<Spinner className="center"></Spinner>
					) : (
							""
						)}
					<div className="p-2 modal-header-bar">
						<span>Summary</span>
						<button
							type="button"
							className="close"
							aria-label="Close"
							onClick={props.toggleModal}
						>
							<X
								style={{ pointerEvents: "none" }}
								color="white"
							/>
						</button>
					</div>
					<div
						style={{
							padding: "20px",
							overflowY: "scroll",
							height: "550px",
						}}
					>
						<div className="row mb-4">
							{/* Old Services Section */}
							<div className="col-md-6">
								<div
									className={`card p-3 h-100 ${props.serviceType === "old"
											? "border border-primary"
											: "opacity-50"
										}`}
								>
									<div className="d-flex align-items-center mb-3">
										<div className="form-check">
											<input
												className="form-check-input"
												type="radio"
												id="oldServices"
												name="serviceType"
												value="old"
												checked={props.serviceType === "old"}
												onChange={(e) => props.setServiceType(e.target.value)}
											/>

											<label
												className="form-check-label font-weight-bold"
												htmlFor="oldServices"
											>
												Old Services
											</label>
										</div>
									</div>

									<label>
										<b>Assign Facilitators</b>
									</label>

									<Select
										maxMenuHeight={220}
										options={props.facilitatorList}
										onChange={props.onSelectHandholder}
										value={props.selectedHandholder}
										placeholder="Select Facilitator"
										isClearable
										isDisabled={props.serviceType !== "old"}
									/>



									{props.flagForOutOfOfficeAndActivateUser === "OutOfOffice" && (
										<div className="mt-3">
											<label>
												<b>Select Date Range</b>
											</label>

											<div className="d-flex">
												<ReactDatePicker
													className="form-control mr-2"
													dateFormat="dd/MM/yyyy"
													selected={props.fromDate}
													onChange={(date) => props.setfromDate(date)}
													placeholderText="From Date"
													minDate={new Date()}
													disabled={props.serviceType !== "old"}
												/>

												<ReactDatePicker
													className="form-control"
													dateFormat="dd/MM/yyyy"
													selected={props.toDate}
													onChange={(date) => props.settoDate(date)}
													placeholderText="To Date"
													minDate={
														props.fromDate
															? new Date(props.fromDate)
															: new Date()
													}
													disabled={props.serviceType !== "old"}
												/>
											</div>
										</div>
									)}
								</div>
							</div>

							{/* New Services Section */}
							<div className="col-md-6">
								<div
									className={`card p-3 h-100 ${props.serviceType === "new"
											? "border border-primary"
											: "opacity-50"
										}`}
								>
									<div className="d-flex align-items-center mb-3">
										<div className="form-check">
											<input
												className="form-check-input"
												type="radio"
												id="newServices"
												name="serviceType"
												value="new"
												checked={props.serviceType === "new"}
												onChange={(e) => props.setServiceType(e.target.value)}
											/>

											<label
												className="form-check-label font-weight-bold"
												htmlFor="newServices"
											>
												New Services
											</label>
										</div>
									</div>
									<div>
									<label>
										<b>Service Assign Algorithm</b>
									</label>

									<Select
										maxMenuHeight={220}
										options={props.serviceAssignAlgo}
										onChange={props.onSelectAlgorithm}
										value={props.selectedAlgo}
										placeholder="Select Algorithm"
										isClearable
										isDisabled={props.serviceType !== "new"}
									/>
									</div>
									<div className="mt-2">
									<label>
										<b>Assign Facilitators</b>
									</label>

									<Select
										maxMenuHeight={220}
										// options={props.facilitatorListForNewService}
											options={props.facilitatorListForNewService.filter(
												(item) => item.email !== props.userModalData.email
											)}
										onChange={props.onSelectNewFacilitator}
										value={props.selected_assign_facilitator}
										placeholder="Select Facilitator"
										isClearable
										isDisabled={props.serviceType !== "new" || props.selectedAlgo?.value == "Round Robin"}
									/>
									</div>

									

									{props.flagForOutOfOfficeAndActivateUser === "OutOfOffice" && (
										<div className="mt-2">
											<label>
												<b>Select Date Range</b>
											</label>

											<div className="d-flex">
												<ReactDatePicker
													className="form-control mr-2"
													dateFormat="dd/MM/yyyy"
													selected={props.newFromDate}
													onChange={(date) => props.setNewFromDate(date)}
													placeholderText="From Date"
													minDate={new Date()}
													disabled={props.serviceType !== "new"}
												/>

												<ReactDatePicker
													className="form-control"
													dateFormat="dd/MM/yyyy"
													selected={props.newToDate}
													onChange={(date) => props.setNewToDate(date)}
													placeholderText="To Date"
													minDate={
														props.newFromDate
															? new Date(props.newFromDate)
															: new Date()
													}
													disabled={props.serviceType !== "new"}
												/>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>

						<div className="mt-3">
							<Button
							// className={`${/*(props.selectedFacilitator === undefined &&
							// 	props.numberOfServices !== 0) ||*/
							// 	props.isLoadingServices === true
							// 	? "disable"
							// 	: ""
							// 	}`}
							// onClick={
							// 	props.flagForOutOfOfficeAndActivateUser === "OutOfOffice"
							// 		? props.handleOutOfOfficeAndReassign
							// 		: props.flagForOutOfOfficeAndActivateUser === "Activate" && props.handleDeactivateAndReassign
							// }
							onClick={props.onViewServices}
						>
							{props.viewServices ? 'Hide Services' : 'View Services'}
						</Button>
							{props.viewServices ?
								<>
									<span className="mt-2 d-block">
										Total number of services : <b>{props.numberOfServices}</b>
									</span>
									{renderRelatedServices()}
								</>
								:
								""
							}
						</div>
					</div>
					{/* <>
							<div className="row" style={{marginTop:"5px"}}>
								<div className={`col-md-6 ${props.numberOfServices === 0 ||
										props.isLoadingServices === true
										? "disable"
										: ""
										}`}
								>
									<label>
										<b>Assign Facilitators</b>
									</label>
									<Select
										maxMenuHeight={220}
										options={ props.facilitatorList}
										onChange={props.onSelectHandholder}
										value={props.selectedHandholder}
										isClearable
									/>	
									<div style={{clear:"both"}}></div>								
									<span>
										Total number of services :{" "}
										<b>{props.numberOfServices}</b>
									</span>						
								</div>
								{props.flagForOutOfOfficeAndActivateUser === "OutOfOffice"?(
								<div class="col-md-6">
									<label>
										<b>Select Date Range</b>
									</label>
									<div class="inline-margin-userview">
										<ReactDatePicker
											dateFormat="dd/MM/yyyy"
											selected={props.fromDate}
											onChange={(date) =>props.setfromDate(date)}
											placeholderText="From Date"
											minDate={new Date()}
										/>
										<ReactDatePicker
											dateFormat="dd/MM/yyyy"
											selected={props.toDate}
											onChange={(date) =>props.settoDate(date)}
											placeholderText="To Date"
											minDate={ props.fromDate ? new Date(props.fromDate) : new Date() }
										/>
									</div>
								</div>):("")}
								
							</div>
							<div>{renderRelatedServices()}</div>
						</> */}
					<div style={{ padding: "10px" }}>
						<Button
							className={`${/*(props.selectedFacilitator === undefined &&
								props.numberOfServices !== 0) ||*/
								props.isLoadingServices === true
								? "disable"
								: ""
								}`}
							onClick={
								props.flagForOutOfOfficeAndActivateUser === "OutOfOffice"
									? props.handleOutOfOfficeAndReassign
									: props.flagForOutOfOfficeAndActivateUser === "Activate" && props.handleDeactivateAndReassign
							}
						>
							{`${props.flagForOutOfOfficeAndActivateUser === "OutOfOffice" ? (!props.userModalData.out_of_office) &&
								// (props.numberOfServices !== 0 && props.selectedFacilitator? "Mark Out of office and reassign" : props.selected_assign_facilitator ? "Mark Out of office and reassign" : "Mark Out of office")
								(props.selectedFacilitator? "Mark Out of office and reassign" : props.serviceType === 'new' && props.selected_assign_facilitator ? "Mark Out of office and reassign" : "Mark Out of office")
								: (props.flagForOutOfOfficeAndActivateUser === "Activate" && props.userModalData.is_active) &&
								(props.numberOfServices === 0 ? "Deactivate" : "Deactivate and Resassign")
								}`}
						</Button>
						<span
							className="ml-2 cursor-pointer"
							onClick={props.toggleModal}
						>
							Cancel
						</span>
					</div>
				</div>
			</ModalContent>
		</Modal>
	);
}
